module.exports = __webpack_public_path__ + "img/VRP_Logo_MILITARY.260126a9.png";